import { Component, HostBinding, NgZone } from '@angular/core';
import { UserData } from '../../src/app/shared/models/user.model';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders, HttpResponse } from "@angular/common/http";
import { environment } from "../../src/environments/environment";
import { ServiceHelper } from '../../src/app/services/servicehelper'
import { filter } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { CapacityModelService } from "./services/CapacityModel-Service";
import { AuthHelper } from './services/authHelper';
import { Constants } from './app.constants';
@Component({
  selector: 'app-masthead',
  templateUrl: './app-masthead.html',
  providers: [ServiceHelper]
})
export class AppMastheadComponent {
  @HostBinding('class.masthead') get isMasthead() { return true; }
  @HostBinding('style.display') get isDisplayBlock() { return 'block'; }
  userData = new UserData();
  imageSource: any;
  emailaddress!: string;
  isInLogin: boolean = false;
  constructor(private httpclient: HttpClient, public router: Router, public service: ServiceHelper, private route: ActivatedRoute, private domSanitizer: DomSanitizer,
    private capacityModelService: CapacityModelService,private authHelper:AuthHelper,private ngZone: NgZone) {
  }
  ngOnInit() {
    
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData != null) {
       let isAccessTokenExpired = this.service.isTokenExpired(this.userData.AccessToken);
      if (!isAccessTokenExpired) {
        // document.getElementById("spnEmployeeName")!.innerText = this.userData.Name;
        // let img = <HTMLImageElement>document.getElementById("insn_userprofile_snap_img");
        // img.src = this.userData.Image;
        // img.style.visibility = "visible";
       // this.loadUser();
      } else {
        localStorage.removeItem("userprofile");
        localStorage.removeItem("isInLogin");
        localStorage.removeItem("isInGetRoles");
      }
    } else{
      if( localStorage.getItem("isInLogin") == null || localStorage.getItem("isInLogin") == "false"){
        localStorage.setItem("isInLogin", "true" )
        this.authHelper.login(); 
      }
    }
  }
  ngAfterViewInit(): void {
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData != null && this.userData != undefined) {
      document.getElementById("lblEmployeeName")!.innerText = this.userData.Name;  
      // let img = <HTMLImageElement>document.getElementById("insn_userprofile_snap_img");  
      // img.src = this.userData.Image;
      //img.style.visibility = "visible";
      this.loadUser();
    }
  }
  RedirectToHome() {
    this.ngZone.run(() => this.router.navigate([Constants.defaultRoute])).then();
  }
  ExpandCollapseMenu(role: string, routeName: string) {
    document.getElementById("MenuPane_" + role)!.classList.add("is-expanded");
    document.getElementById("MenuPane_" + role)!.style.height = "auto";
    document.getElementById("MenuPane_" + role)!.style.display = "block";
    document.getElementById("Menu_" + role)!.classList.remove("is-selected");
    document.getElementById("Menu_" + role)!.classList.add("is-expanded", "child-selected");
    var menuId = document.getElementById("Menu_" + role)!;
    menuId.getElementsByTagName("svg")[0].classList.add("active");
    document.getElementById("Item_" + routeName)!.classList.add("is-focused", "is-selected");
    this.router.navigateByUrl(routeName);
  }
  loadContent() {
    let UserDetails = new UserData();
    let isImageExists: boolean = false;
    UserDetails = JSON.parse(localStorage.getItem("userprofile")!);

    var httpOptions = {
      headers: new HttpHeaders({
        'Authorization': "Bearer " + UserDetails.AccessToken,
        'content-type': 'application/json'
      }),
      responseType: 'blob' as const,
    };
    if (UserDetails != null) {
      isImageExists = UserDetails != null ? (UserDetails.Image != undefined && UserDetails.Image != null) : false;
      if (!isImageExists) {
        if (UserDetails.AccessToken != null) {
          this.httpclient.get(environment.AADUserImageUrl, httpOptions)
            .subscribe((response: any) => {
              var mediaType = response.Type;
              var blob = new Blob([response._body], { type: mediaType });
              let reader = new FileReader();
              reader.addEventListener("load", () => {
                UserDetails.Image = reader.result;
                this.userData = UserDetails;
                this.loadUser();
                localStorage.setItem("userprofile", JSON.stringify(UserDetails))
              }, false);
              if (blob) {
                reader.readAsDataURL(blob);
              }
            })
        } else {
          this.router.navigate(["login"]);
        }
      } else {
        this.userData = UserDetails;
        this.loadUser();
      }
    } else {
      this.router.navigate(["login"]);
    }
  }
  private loadUser() {
    document.getElementById("lblEmployeeName")!.innerText = this.userData.Name;
    let img = <HTMLImageElement>document.getElementById("insn_userprofile_snap_img");

    var httpOptions = {
      headers: new HttpHeaders({ 'Authorization': "Bearer " + this.userData.AccessToken }),
      responseType: 'arraybuffer' as const,
    };
    this.httpclient.get(environment.AADUserImageUrl, httpOptions)
      .subscribe((response: any) => {
        var arrayBufferView = new Uint8Array(response);
        var blob = new Blob([arrayBufferView], { type: "image/jpeg" });
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(blob);
        this.userData.Image = imageUrl;
        img.src = this.userData.Image;
        img.style.visibility = "visible";
        localStorage.setItem("userprofile", JSON.stringify(this.userData))
        //console.log(imageUrl);
      })
  }

  AddErrorDetails(error: Response) { }
}
